/**
 * Menu Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var utils = require('utils');
    var MenuModel = require('modules/menu/menu.model');
    var device = require('util/device.util');
    var config = require('config');

    module.exports = MenuModel.extend({

        getInitialClonedItems: function() {
            var updateFriendlyUrl = function(item) {
                if (item.url === '/') {
                    item.friendlyURL = '/';
                }
            };

            var markMenuItemAsOpener = function(item) {
                var chatConfig = config.get('chatWidget');
                var inboxConfig = config.get('inboxWidget');
                var registrationURL = config.get('registrationURL');

                if (inboxConfig && inboxConfig.enabled && inboxConfig.counterPage === item.url) {
                    item.inboxOpener = true;
                }

                if (chatConfig && chatConfig.enabled && chatConfig.counterPage === item.url) {
                    item.chatOpener = true;
                }

                if(registrationURL === item.url) {
                    item.isRegisterBtn = true;
                }
            };

            return utils.deepClone(config.get('menuItems'))
                ?.map(function(item) {
                updateFriendlyUrl(item);

                markMenuItemAsOpener(item);

                if (item.children) {
                    item.children.forEach(function(child) {
                        // For case when item has the same link as one of children
                        updateFriendlyUrl(child);

                        // Find and mark inbox opener among children
                        markMenuItemAsOpener(child);
                    });

                    if (device.formFactor === 'mobile') {
                        item.expandable = _.isUndefined(item.expandablePageMobile) ? true : item.expandablePageMobile;
                        item.expandedByDefault =
                            _.isUndefined(item.expandedByDefaultMobile) ? false : item.expandedByDefaultMobile;
                    } else if (device.formFactor === 'tablet') {
                        item.expandable = _.isUndefined(item.expandablePageTablet) ? true : item.expandablePageTablet;
                        item.expandedByDefault =
                            _.isUndefined(item.expandedByDefaultTablet) ? false : item.expandedByDefaultTablet;
                    }
                }

                return item;
            }) ?? [];
        }
    });
});
